import React from 'react'
import { useState, useEffect } from 'react';

import { Typography, Dialog } from '@mui/material'

interface ConfirmationModalProps {
    textContent: string;
    activated: boolean;
    setActivated: React.Dispatch<React.SetStateAction<boolean>>;
    setPage: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ textContent, activated, setActivated, setPage, }) => {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false)
        setPage()
    }

    useEffect(() => {
        if (activated) {
            setOpen(true)

            const preventClicks = (event: Event) => {
                event.preventDefault();
                event.stopImmediatePropagation();
            }

            document.body.addEventListener("click", preventClicks, true)

            setTimeout(() => {
                document.body.removeEventListener("click", preventClicks, true)
                handleClose()
            }, 1500)
        }
    }, [activated])


    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperProps={{ sx: { padding: "3rem" } }}
            >
                <Typography variant="h1"
                    sx={{
                        border: "solid 3px #41b771",
                        borderRadius: "40px",
                        py: 8,
                        px: 5,
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    {textContent}
                </Typography>
            </Dialog>
        </>
    )
}

export default ConfirmationModal
